import {
	IPushesViewContext,
	PushesViewContext,
} from '../../../../../pushesViewContext/pushesViewState/pushesViewContext';
import React, { useContext } from 'react';
import SearchField from 'components/SearchField/SearchField';

const Search: React.FC = () => {
	const { changeSearchString, searchString } = useContext<IPushesViewContext>(PushesViewContext);

	return <SearchField onChangeSelectSearchString={changeSearchString} searchString={searchString} delay={800} />;
};

export default Search;
